// navigation-provider.js
import { extendTheme } from "@mui/material";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

export const getNavigationProvider = (rol) => [
  {
    kind: "header",
    title: "Barra de navegación",
  },
  {
    segment: "dashboard-provider/list-patients",
    title: rol === "Coach" ? "Corredores" : "Pacientes",
    icon: <PeopleAltIcon />,
  },
  {
    segment: "dashboard-provider/add-patient",
    title: rol === "Coach" ? "Agregar Corredor" : "Agregar Paciente",
    icon: <GroupAddIcon />,
  },
  ...(rol === "Coach"
    ? [
        {
          segment: "dashboard-provider/runing-clubs-provider",
          title: "Club de Corredores",
          icon: <Diversity3Icon />,
        },
      ]
    : []),
];

export const demoTheme = extendTheme({
  colorSchemes: { dark: true },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(212, 216, 216, 0.32)",
            "& .MuiListItemIcon-root, & .MuiSvgIcon-root": {
              color: "#e7ef7d !important",
            },
          },
        },
      },
    },
  },
});
